import { LoadablePaint } from '@confluence/loadable';
// eslint-disable-next-line no-restricted-imports
import type { LoadableType } from '@confluence/loadable/src/types.ts';

import type { TeamCalendarMacroProps } from './TeamCalendarMacro.tsx';
import { TeamCalendarMacroSsrPlaceholder } from './TeamCalendarMacroSsrPlaceholder.tsx';

export const TeamCalendarMacroLoadablePlaceholder = TeamCalendarMacroSsrPlaceholder;

export const TeamCalendarMacroLoader: LoadableType<TeamCalendarMacroProps> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-TeamCalendarMacro" */ './TeamCalendarMacro.tsx'))
			.TeamCalendarMacro,
	loading: TeamCalendarMacroLoadablePlaceholder,
});
